__turbopack_context__.v({
  "actions": "Stories-module-scss-module__GsQi7G__actions",
  "cards": "Stories-module-scss-module__GsQi7G__cards",
  "error": "Stories-module-scss-module__GsQi7G__error",
  "filters": "Stories-module-scss-module__GsQi7G__filters",
  "intro": "Stories-module-scss-module__GsQi7G__intro",
  "introInner": "Stories-module-scss-module__GsQi7G__introInner",
  "stories": "Stories-module-scss-module__GsQi7G__stories",
});
